import { render, staticRenderFns } from "./Catching.vue?vue&type=template&id=ab3caa8c&scoped=true&"
import script from "./Catching.vue?vue&type=script&lang=js&"
export * from "./Catching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3caa8c",
  null
  
)

export default component.exports